import React from 'react';

const FileTypeZip = () => (
    <svg height="18" viewBox="0 0 15 18" width="15" xmlns="http://www.w3.org/2000/svg">
        <g fill="none">
            <path
                d="m.47845204 0c-.26424419 0-.47845204.21053571-.47845204.61907143v17.05949997c0 .1108929.21420785.3214286.47845204.3214286h13.10559596c.2642441 0 .478452-.2105357.478452-.3214286l.0055618-13.1644265c-.9806671-.62546539-3.4313735-3.08345032-4.48146053-4.5141449z"
                fill="#ffe797"
            />
            <path
                d="m4.56416016 16.4311523h1.70947265v.4438477h-2.38183593v-.3603516l1.65454101-2.390625h-1.64355469v-.4482422h2.31811524v.3515626zm2.88544921.4438477h-.55371093v-3.1992188h.55371093zm1.35175782-1.1887207v1.1887207h-.55590818v-3.1992188h1.22387693c.35742363 0 .64123426.0930167.85144046.2790528.2102061.1860361.3153076.4321274.3153076.7382813 0 .3134781-.1029042.5573721-.3087159.7316894-.2058115.1743173-.49401664.2614746-.86462393.2614746zm0-.4460449h.66796875c.19775492 0 .34863227-.0465084.45263672-.1395264.10400444-.093018.15600584-.2274161.15600584-.4031983 0-.1728524-.0527338-.3109125-.15820308-.4141845-.10546931-.103272-.25048738-.156372-.4350586-.1593018h-.68334963z"
                fill="#695e3d"
            />
            <g fill="#998a5a">
                <path d="m5.625 1.125h1.125v1.125h-1.125z" />
                <path d="m6.75 0h1.125v1.125h-1.125z" />
                <path d="m6.75 2.25h1.125v1.125h-1.125z" />
                <path d="m5.625 3.375h1.125v1.125h-1.125z" />
                <path d="m6.75 4.5h1.125v1.125h-1.125z" />
                <path d="m5.625 5.625h1.125v1.125h-1.125z" />
                <path d="m6.75 6.75h1.125v1.125h-1.125z" />
                <path d="m5.625 9h1.125v1.125h-1.125z" />
                <path d="m5.625 7.875h1.125v1.125h-1.125z" />
                <path d="m6.75 9h1.125v1.125h-1.125z" />
            </g>
        </g>
    </svg>
);

export default FileTypeZip;
